// ======================================================================
// FILE:
// src/modules/wms/reports/components/ReportFilter.jsx
//
// MODULE:
// Work Management System (WMS)
//
// FEATURE:
// Open Work Register Filters
// ======================================================================

import React from "react";

export default function ReportFilter({

    filters,

    onChange,

    onSearch,

    onReset,

}) {

    return (

        <div
            style={{

                background: "#fff",

                borderRadius: 14,

                padding: 16,

                marginBottom: 20,

                boxShadow:
                    "0 2px 8px rgba(0,0,0,0.06)",

            }}
        >

            <div
                style={{

                    display: "grid",

                    gridTemplateColumns:
                        "repeat(auto-fit,minmax(220px,1fr))",

                    gap: 14,

                }}
            >

                {/* ================================================= */}
                {/* GLOBAL SEARCH */}
                {/* ================================================= */}

                <input

                    type="text"

                    className="form-control"

                    placeholder="Search Work No, Title, Priority, Status..."

                    value={filters.search || ""}

                    onChange={(e) =>
                        onChange(
                            "search",
                            e.target.value
                        )
                    }

                />

                {/* ================================================= */}
                {/* FROM DATE */}
                {/* ================================================= */}

                <input

                    type="date"

                    className="form-control"

                    value={filters.from_date}

                    onChange={(e) =>
                        onChange(
                            "from_date",
                            e.target.value
                        )
                    }

                />

                {/* ================================================= */}
                {/* TO DATE */}
                {/* ================================================= */}

                <input

                    type="date"

                    className="form-control"

                    value={filters.to_date}

                    onChange={(e) =>
                        onChange(
                            "to_date",
                            e.target.value
                        )
                    }

                />

                {/* ================================================= */}
                {/* STATUS */}
                {/* ================================================= */}

                <select

                    className="form-select"

                    value={filters.status}

                    onChange={(e) =>
                        onChange(
                            "status",
                            e.target.value
                        )
                    }

                >

                    <option value="">
                        All Status
                    </option>

                    <option value="OPEN">
                        Open
                    </option>

                    <option value="IN_PROGRESS">
                        In Progress
                    </option>

                    <option value="PENDING_APPROVAL">
                        Pending Approval
                    </option>

                </select>

                {/* ================================================= */}
                {/* PRIORITY */}
                {/* ================================================= */}

                <select

                    className="form-select"

                    value={filters.priority}

                    onChange={(e) =>
                        onChange(
                            "priority",
                            e.target.value
                        )
                    }

                >

                    <option value="">
                        All Priority
                    </option>

                    <option value="CRITICAL">
                        Critical
                    </option>

                    <option value="HIGH">
                        High
                    </option>

                    <option value="MEDIUM">
                        Medium
                    </option>

                    <option value="LOW">
                        Low
                    </option>

                </select>

                {/* ================================================= */}
                {/* RECURRING */}
                {/* ================================================= */}

                <select

                    className="form-select"

                    value={filters.is_recurring}

                    onChange={(e) =>
                        onChange(
                            "is_recurring",
                            e.target.value
                        )
                    }

                >

                    <option value="">
                        All Work
                    </option>

                    <option value="true">
                        Recurring
                    </option>

                    <option value="false">
                        Non Recurring
                    </option>

                </select>
                {/* ================================================= */}
                {/* ACTION BUTTONS                                    */}
                {/* ================================================= */}

                <div
                    style={{
                        display: "flex",
                        gap: 10,
                        alignItems: "center",
                    }}
                >

                    <button
                        className="btn btn-primary"
                        onClick={onSearch}
                    >
                        Search
                    </button>

                    <button
                        className="btn btn-secondary"
                        onClick={onReset}
                    >
                        Reset
                    </button>

                </div>

            </div>

        </div>

    );

}